<template>
  <div class="loading">
    <div class="left"><span>BLACKBEANS</span></div>
    <img class="middle" src="../assets/loading.png" alt="">
    <div class="right"><span>SOFTWARE</span></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    props: ['landscape']
  }
</script>

<style lang="scss" scoped>
@import '../Global.scss';
.loading {
  @include flexBox(row, nowrap, space-between, center);
  @extend .center;
  .middle {
    width: .04rem;
    height: .43rem;
    animation: rotation 1s linear infinite;
  }
  .left {
    width: 2.7rem;
    height: .3rem;
    color: #000;
    margin-right: .3rem;
    text-align: right;
    overflow: hidden;
    span {
      display: block;
      font-size: .24rem;
      font-weight: 100;
      transform: translateY(.3rem);
      animation: slideUp 2s linear infinite;
    }
  }
  .right {
    @extend .left;
    margin-left: .3rem;
    text-align: left;
    span {
      transform: translateY(-.3rem);
      animation: slideDown 2s linear infinite;
    }
  }
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(-15deg);
  }
  50%, 100% {
    transform: rotate(180deg);
  }
  
}
@keyframes slideUp {
  0% {
    transform: translateY(.3rem);
  }
  25%, 50% {
    transform: translateY(0);
  }
  75%, 100% {
    transform: translateY(-.3rem);
  }
}
@keyframes slideDown {
  0% {
    transform: translateY(-.3rem);
  }
  25%, 50% {
    transform: translateY(0);
  }
  75%, 100% {
    transform: translateY(.3rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue